import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { colors } from '../styles/colors'
import { useDispatch, useSelector } from 'react-redux'
import firebase from 'firebase/app'
import { useFirebaseConnect } from 'react-redux-firebase'
import { getFormatedData } from '../functions/getFormatedData'

const new_order_indicator_styles = `
:after {
    content: '';
    width: 1rem;
    height: 1rem;
    position: absolute;
    top: -2px;
    right: -10px;
    background: green;
    border-radius: 50%;
}
:hover {
    :after {
        background: ${colors.red};
    }
}
`
const Container = styled.div`
    padding-bottom: 2rem;

    .width-limiter {
        display: flex;
        justify-content: center;
    }

    .links {
        display: flex;
        flex-wrap: wrap;
    }

    a, p {
        font-family: 'Lato', sans-serif;
        font-size: 2rem;
        font-weight: 300;
        text-decoration: none;
        text-align: center;
        white-space: nowrap;
        color: ${colors.dark_blue};

        padding: 2rem 1rem 0 1rem;

        :not(:last-child) {
            margin-right: 2rem;
        }
    }
    a, 
    .categories-tools,
    .log-out {
        :hover {
            cursor: pointer;
            color: ${colors.red};
        }
    }

    .link-active {
        color: ${colors.red};
    }

    .orders-link {
        position: relative;

        ${ props => props.new_orders ? new_order_indicator_styles : null }
    }

`

export const AdminNavigation = () => {
    const dispatch = useDispatch()

    useFirebaseConnect('orders')
    const orders = getFormatedData(useSelector( state => state.firebase.data.orders))
    const there_are_new_orders = orders.filter( order => order.status === 'new' ).length !== 0
    
    function handleLogout() {
        const logout_confirm = window.confirm('Вы действительно хотите выйти?')
        if (logout_confirm) {
            firebase.logout()
        }
    }
    return (
        <Container new_orders={there_are_new_orders}>
            <div className="width-limiter">
                <p className="title"> <b>Admin /</b> </p>
                <div className="links">
                    <NavLink activeClassName='link-active' to='/admin/main-data' > Основные данные </NavLink>
                    <NavLink activeClassName='link-active' to='/admin/orders' > <div className='orders-link' >Заказы</div> </NavLink>
                    <p className='categories-tools' onClick={() => dispatch({ type: 'CHANGE_CATEGORIES_OPENED' })} >Категории</p>
                    <p className='log-out' onClick={() => handleLogout()} >Завершить сессию</p>
                </div>
            </div>
        </Container>
    )
}
